import './CarModelDetailsDesktop.scss';
import { motion } from 'framer-motion';
import Carousel from '../Carousel/Carousel';
import CloseIcon from '../../../../../assets/icons/close.svg';
import React from 'react';
import Marks from '../Marks/Marks';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function CarModelDesktop({ tab, swiperRef, onClickMark, onClose, setSlideIndex }) {
  const isOpen = tab.marks.some((el) => el.open);
  // const isOpen = Array.isArray(tab) ? tab.some((el) => el.open) : false;

  return (
    <div className={'car-model-details-desktop'}>
      <div className={'wrapper'} data-aos="fade-up">
        <motion.div
          className={'left'}
          initial={{ width: '100%', opacity: 1 }}
          animate={{ width: isOpen ? '65%' : '100%', opacity: 1 }}
          transition={{ duration: 0.7, ease: 'easeInOut' }}
        >
          <div className={'left_image'}>
            <Image field={tab.image} alt={'img'} fill />
          </div>
          <Marks tab={tab} onClickMark={onClickMark} />
          <motion.button
            className={'close'}
            onClick={onClose}
            initial={{ visibility: 'hidden', opacity: 0 }}
            animate={{ visibility: isOpen ? 'visible' : 'hidden', opacity: isOpen ? 1 : 0 }}
            transition={{ duration: 0.7, ease: 'easeInOut' }}
          >
            <img src={CloseIcon} alt={'x'} />
          </motion.button>
        </motion.div>

        {/* 只在激活时渲染右侧区域，避免占用空间 */}
        {isOpen && (
          <motion.div
            className={'right'}
            initial={{ width: 0, opacity: 0 }}
            animate={{ width: '35%', opacity: 1 }}
            transition={{ duration: 0.7, ease: 'easeInOut' }}
          >
            <Carousel marks={tab.marks} swiperRef={swiperRef} setSlideIndex={setSlideIndex} />
          </motion.div>
        )}
      </div>
    </div>
  );
}
